<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.soft.skills.title')"
        :field-author-and-date="qualification.softSkills"
        data-testid="admin-section-tabs-qualification-soft-skills"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.softSkills"
            :placeholder="$t('profile.vetting.qualification.soft.skills.placeholder')"
            autogrow
            data-testid="vetting-soft-skills-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.softSkills"
            :replace-by="$t('profile.vetting.qualification.soft.skills.empty.placeholder')"
            data-testid="vetting-soft-skills"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);
</script>
